import { Formik, Form } from "formik";
import { signupValidationsSchema } from "../../../utils/validations";
import { ISignup } from "./signup.interface";
import { useNavigate } from "react-router-dom";
import { RegisterUser } from "../../../services/auth.service";
import { useState } from "react";
import FormikInput from "../../../components/FormikFieldCustom";
import { StatusCodes } from "http-status-codes";
import ButtonLoader from "../../../components/ButtonLoader";
import { toast } from "react-toastify";
import GooglePlacesAutoComplete from "../../../components/GooglePlacesAutoComplete";
const Signup = () => {
  const navigate = useNavigate();
  const [errorMessages, setErrorMessages] = useState<any>({
    error: null,
  });
  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    website: "",
    mobile_number: "",
    password: "",
    state: "",
    company_name: "",
    address: "",
    retypePassword: "",
    city: "",
    zip: "",
    country: "",
    auctioner_licenses: "",
  };

  return (
    <div className="flex justify-center flex-col items-center min-h-screen">
      <h1 className="text-center">Create a Auctioner account</h1>
      <Formik
        validationSchema={signupValidationsSchema}
        initialValues={initialValues}
        onSubmit={async (values: ISignup, { setSubmitting }) => {
          const newValues = { ...values, street_address: values.address };
          setSubmitting(true);
          const response: any = await RegisterUser(newValues);
          if (response.status && response.status_code === StatusCodes.OK) {
            setErrorMessages({ error: null });
            navigate("/verify-account", { state: { email: values.email } });
          } else {
            setErrorMessages({ message: response.message });
            toast.error(response?.message);
          }
          setSubmitting(false);
        }}
      >
        {({ setFieldValue, isSubmitting }) => (
          <Form className="mt-3 mb-2">
            <div className="grid md:grid-cols-2 gap-4  xs:grid-cols-1 sm:grid-cols-2">
              <FormikInput name="company_name" label="Company Name" />
              <FormikInput name="first_name" label="First Name" />
              <FormikInput name="last_name" label="Last Name" />
              <div>
                <label className="block mb-2 text-sm text-gray-800">
                  Address
                </label>
                <GooglePlacesAutoComplete setFieldValue={setFieldValue} />
              </div>

              <FormikInput
                name="city"
                label="City"
                type="text"
                autoComplete="address-level2"
              />
              <FormikInput
                name="state"
                label="State"
                type="text"
                autoComplete="address-level3"
              />
              <FormikInput
                name="country"
                label="Country"
                type="text"
                autoComplete="country-name"
              />

              <FormikInput
                name="zip"
                label="Zip"
                type="text"
                autoComplete="zip"
              />
              <FormikInput
                name="email"
                label="Email"
                extraValidations={
                  errorMessages?.message?.["email"]
                    ? errorMessages?.message?.["email"]
                    : null
                }
              />
              <FormikInput
                name="mobile_number"
                label="Phone"
                type="number"
                extraValidations={
                  errorMessages?.message?.["mobile_number"]
                    ? errorMessages?.message?.["mobile_number"]
                    : null
                }
              />
              <FormikInput
                name="auctioner_licenses"
                label="Auctioner License"
              />
              <FormikInput type={"password"} name="password" label="Password" />
              <FormikInput
                type={"password"}
                name="retypePassword"
                label="Re-type Password"
              />
              <FormikInput name="website" label="Website" />
              <div className="flex items-center gap-x-2 ">
                <input type="checkbox" />
                <span className="text-xs">
                  I have read and agree to the Terms and Conditions.
                </span>
              </div>
              <br />
              <button
                type="submit"
                className="border-2 px-1 border-gray-600 bg-gray-400 grid grid-cols-1"
              >
                {isSubmitting ? (
                  <>
                    <ButtonLoader />
                    Loading...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Signup;
